export const CONNECTION_TEST_DISMISS_SESSION_KEY = 'connectionTestPopupDismissed'

export function clearConnectionTestSessionDismiss() {
  try {
    sessionStorage.removeItem(CONNECTION_TEST_DISMISS_SESSION_KEY)
  } catch {}
}

export function isConnectionTestSessionDismissed(currentToken?: string | null) {
  if (!currentToken) return false
  try {
    return sessionStorage.getItem(CONNECTION_TEST_DISMISS_SESSION_KEY) === currentToken
  } catch {
    return false
  }
}

export function markConnectionTestSessionDismiss(currentToken?: string | null) {
  if (!currentToken) return
  try {
    sessionStorage.setItem(CONNECTION_TEST_DISMISS_SESSION_KEY, currentToken)
  } catch {}
}
